export default [
  {
    id: 1,
    title: "Ian, Jeannette 1969 & Patricia 2028",
    fullText: [
      "Set both in the present time and the fatidic winter night of 1969 inside the universe of Man Shall Never Know Any Of This, this first episode follows on the previous film narrative arch, with Patricia preparing her character Barbara for the immersion and shooting of her novel's tv series, where she'll debut as an actress. In order to witness the miracle of her creation, she will make herself enter the fiction realm and observe her characters closely and firsthand. As the force of creation pulls her in, she merges with this first alter ego so through the externalization of her genius into one plane of existence she can evolve with the one that individualized from her. While Patricia dives into this process, somewhere in the alive realm of her novel's pages, Ian Pollock is stuck in a never-ending nightmare, being haunted by the ghost of his magnetic ex Sheila who just left him. To the sound of some of the most iconic songs from the first two recently released Led Zeppelin's albums that paved a new movement in the counterculture, bridging the psychedelic 60's with the new, heavier and darker sounds of the 70s, Ian reminisces over his early days with Sheila, how his life felt invincible and how his band kept flourishing with the whirlwind passion of his fiery romance. While Ian fails to accept the redirection that late summer has brought him, somewhere far away in the city, Jeannette Cook daydreams with an adventure that will take her away from the modest introversion of her day-to-day reality and perhaps match the crazy adventures of her identical – but no similar - twin sister Jeanine. If Jeanine is full of spontaneity and passion, flying away from the city to meet rockstars and go on in adventures with the band, Jeannette spends her time in her head, writing, reading and daydreaming of perhaps one day things being different for her.",
      "The two protagonists follow on parallel paths until Patricia's first alter ego starts evolving into her rebelliousness, sensuality and audacity, pushing the threads of fate and pulling the protagonists towards one another inside the story, to the magnetic pole of their fated encounter. Both events happen simultaneously, giving as a chance to understand how decisions in one plane of existence affect the other, how the creator and her creations are part of the same destiny, even though they contain apparently unconnected lives. As Patricia back in time to the winter night of 1969 inside the story's realm as the Barbara that will only be born 24 years later, she watches Ian at the diner where Jeannette goes to read and write and their paths crossing in an evening of unpredictable events. In the diner where her protagonists already sit, to the sound of the enigmatic \"Dark Star\" by Grateful Dead, Patricia dares to experience the story camouflaged in a plot of converging realities and while her pen moves and the creations are given life, they stick to their defined roles and give form to the prophecy that will propel us into a time loop. As Ian invites Jeannette to his band's concert later that night and as their date progresses to dinner, the strange track by Grateful Dead keeps finding them everywhere they go, creating a synchronistic stream of events that eventually leads them together to Ian's house. When Patricia locks the physicality of her character shapeshifting through different lens, perspectives and angles, the cross between the protagonist's distant universes is also understood and the unlikely collision happens in order to create what must be created and to rewrite what must be rewritten. Patricia sits in front of the camera lens ready for action and Ian rolls to Jeannette's side in bed, while the embryo starts slowly fixating in the womb, allowing us to cross directly to the baby's consciousness whose split into different timelines and realities takes us deep inside the fictionalized realm for a journey like no other.",
    ],
    keywords: [
      "female artist",
      "actress",
      "visionary creator",
      "immersive physicality",
      "creator and creation relationship",
      "cause and effect",
      "student",
      "musician",
      "rock concert",
      "heartbreak",
      "couples",
      "fated encounter",
      "couple relations",
      "contrasting expectations",
      "Led Zeppelin",
      "ambition",
      "desire",
      "infatuation",
      "direction and purpose",
      "dreams and expectations",
      "love at first sight",
      "character-driven vs plot-driven",
      "irreversibility",
      "dream and nightmare",
      "longing",
      "daydreaming",
      "counterculture",
    ],
    themes:
      "female artist, actress, visionary creator, immersive physicality, creator and creation relationship, cause and effect, student, musician, rock concert, heartbreak, couples, fated encounter, couple relations, contrasting expectations, Led Zeppelin, ambition, desire, infatuation, direction and purpose, dreams and expectations, love at first sight, character-driven vs plot-driven, irreversibility, dream and nightmare, longing, daydreaming, counterculture.",
    visualStyle:
      "Cool and light warm – pastels, pearl & beige - colored tones (spring-like) and contrasted noir B&W (winter-like). In terms of cinematography, unusual camera angles, immersive soundtrack and long takes with smooth camera movements amplifying the suspense, creating an uninterrupted, immersive experience.",
    visualReferences:
      "Psych Out (1968), Hair (1979), Dazed and Confused (1993), Beyond the Valley of dolls (1970), Head (1968), Easy Rider (1969) for Ian and Jeannette's segments and The Doors (1991), I'm Not There (2007), Fear and Loathing in Las Vegas (1998), Inherent Vice (2014) for Patricia's segments.",
    images: [
      require("@/assets/images/Patricia/images/ep1/0.jpg"),
      require("@/assets/images/Patricia/images/ep1/1.jpg"),
      require("@/assets/images/Patricia/images/ep1/2.jpg"),
      require("@/assets/images/Patricia/images/ep1/3.jpg"),
      require("@/assets/images/Patricia/images/ep1/4.jpg"),
      require("@/assets/images/Patricia/images/ep1/5.jpg"),
      require("@/assets/images/Patricia/images/ep1/6.jpg"),
      require("@/assets/images/Patricia/images/ep1/7.jpg"),
      require("@/assets/images/Patricia/images/ep1/8.jpg"),
      require("@/assets/images/Patricia/images/ep1/9.jpg"),
      require("@/assets/images/Patricia/images/ep1/10.jpg"),
      require("@/assets/images/Patricia/images/ep1/11.jpg"),
      require("@/assets/images/Patricia/images/ep1/12.jpg"),
      require("@/assets/images/Patricia/images/ep1/13.jpg"),
      require("@/assets/images/Patricia/images/ep1/14.jpg"),
      require("@/assets/images/Patricia/images/ep1/15.jpg"),
      require("@/assets/images/Patricia/images/ep1/16.jpg"),
      require("@/assets/images/Patricia/images/ep1/17.jpg"),
      require("@/assets/images/Patricia/images/ep1/18.jpg"),
      require("@/assets/images/Patricia/images/ep1/19.jpg"),
      require("@/assets/images/Patricia/images/ep1/20.jpg"),
      require("@/assets/images/Patricia/images/ep1/21.jpg"),
      require("@/assets/images/Patricia/images/ep1/22.jpg"),
    ],
  },
  {
    id: 2,
    title: "Michael, 2060",
    fullText: [
      "The second episode opens in the town of Mount Shasta, in the future year of 2060, with Michael, 90, the first possible descendancy of Ian and Jeannette. Michael lives in a cottage near the mountain's base and is being visited by his son and grandson Sonny who are moving his belongings as they prepare Michael to relocate to a nursing home. While Michael's son and his wife box his belongings, Michael sits with his grandson in the living room telling him tales about his childhood and family. Michael's line of thought seems affected by his progressive lack of lucidity and rich imagination so, as he mumbles around certain family events, the lines of time and space dissolve by the power of his consciousness and we are taken directly into Mount Shasta's snowy peak and the mountain's inner chambers and secrets. Michael tells Sonny about the iconic Mount Shasta's legend on the lost Lemuria civilization, how his father Ian went missing after a trip to the mountain's top searching for the goddess that no one ever saw and from which he never returned and other interesting facts that allow us to peak through the mountain's consciousness and its secrets. While his words create a collage of strange insights, memories and prophecies, we are taken into an epic tale with Ian while quantum jumping in order to learn more about the family's evolution through Michael's wandering mind that mediates between personal and transpersonal realms. This is the episode where we learn about the family's story and all the characters endings as well as the enigmatic eponymous novel written by an author called Barbara that seems to be an important key in deciphering all of this. Through the epic tale being narrated by Michael, we are taken back to the cottage as Michael's son overhears their conversation and verbalizes his worries around what seem to be glitches in his memory or what Sonny believes are signs of a timeline that no longer exists. As the evening progresses and a storm is formed outside, with thunder and lightning, Michael's consciousness wanders in and out of the family chronology, sensitive to time and space like no other, guiding his grandson into a living dream of myths and long forgotten tales. As the afternoon progresses into twilight, Sonny's parents go out to drop some of the bigger boxes and Michael and his grandson put on a Pink Floyd record while Sonny go through some of his grandfather's old special belongings. In one of the boxes, Sonny finds a pocket watch from Prague and decides to try a hypnotism trick on Michael. As Michael slips into trance his consciousness travels to a parallel realm and the sound of waves washing over the coast engulf us, providing us with the second door to the other possible progeny.",
    ],
    keywords: [
      "old man",
      "enigmatic tale",
      "living alone",
      "father & son relationship",
      "grandfather and grandson relationship",
      "small town",
      "legends & myths",
      "mandela effect",
      "mysterious plot",
      "memory",
      "recurring dream",
      "riddle",
      "family relations",
      "life lessons",
    ],
    themes:
      "old man, enigmatic tale, living alone, father & son relationship, grandfather and grandson relationship, small town, legends & myths, mandela effect, mysterious plot, memory, recurring dream, riddle, family relations, life lessons.",
    visualStyle:
      "Cool tones with strong contrast growing into progressive warm bright and fresh tones (symbolizing the coming out of deep winter into spring). The whole film will have cool undertones, providing a dreamy immersive feeling, where blues, purples and pinks are predominant when associated with the mountain landscape.",
    visualReferences:
      "Cold Mountain, Burning 2018, The Revenant, The Assassination Of Jesse James By The Coward Robert Ford (visual, color grading, environment – similar to The Mountain/1st collection).",
    images: [
      require("@/assets/images/Patricia/images/ep2/1.jpg"),
      require("@/assets/images/Patricia/images/ep2/2.jpg"),
      require("@/assets/images/Patricia/images/ep2/3.jpg"),
      require("@/assets/images/Patricia/images/ep2/4.jpg"),
      require("@/assets/images/Patricia/images/ep2/5.jpg"),
      require("@/assets/images/Patricia/images/ep2/6.jpg"),
      require("@/assets/images/Patricia/images/ep2/7.jpg"),
      require("@/assets/images/Patricia/images/ep2/8.jpg"),
      require("@/assets/images/Patricia/images/ep2/9.jpg"),
      require("@/assets/images/Patricia/images/ep2/10.jpg"),
      require("@/assets/images/Patricia/images/ep2/11.jpg"),
      require("@/assets/images/Patricia/images/ep2/12.jpg"),
      require("@/assets/images/Patricia/images/ep2/13.jpg"),
      require("@/assets/images/Patricia/images/ep2/14.jpg"),
      require("@/assets/images/Patricia/images/ep2/15.jpg"),
      require("@/assets/images/Patricia/images/ep2/16.jpg"),
      require("@/assets/images/Patricia/images/ep2/17.jpg"),
      require("@/assets/images/Patricia/images/ep2/18.jpg"),
      require("@/assets/images/Patricia/images/ep2/19.jpg"),
    ],
  },
  {
    id: 3,
    title: "Bonnie, 2018",
    fullText: [
      "The third episode opens in the counseling's office, during Bonnie's weekly session of hypnotherapy. As Bonnie, 48, receives what seems to be the displaced sound of waves crashing that came from Michael's consciousness while they are both in trance, Dr Susan follows the hint and they end up talking about her wise and unique grandmother Lizz and her beach house near Sonoma's coast. As the session progresses, they go over Bonnie's childhood, her parents irreconcilable differences and the unconfessable fantasies she keeps having since 2013 of her husband dying so she can conceive a new founded sense of freedom and independence. As Bonnie realizes her background might be more connected to her present situation than what she was anticipating, the session comes to an end, and she goes back to her almost perfect family life and the furniture restauration business she owns with her husband. Throughout that day, as the sound of waves crashing keeps coming in, contrasting the secret fantasies she keeps entertaining of her husband dying, Bonnie decides to take a road trip to Sonoma to see grandmother Lizz, clear her mind and try to find out more about her parents story. Filled with both nostalgia and a sense of freedom and possibility, Bonnie sets out on the journey, sure that in one version of reality she departed in the company of her daughters and a happier married version of herself whilst on another she is all by herself and seeking change. As both realities overlap giving us two perspective on the variations causing a split, we go into Bonnie's subconscious and understand how haunted she feels by the expectations that her family life is having on her and how infatuated she is by this new sense of childlike freedom and possibility that is being ignited in her. As her trip ends with the sunset emerging in the sky in Sonoma's coast, Bonnie calls her husband to tell him she will stay over for a few days. Lizz and Bonnie sit down for an afternoon tea and as they go over old memories and photographs at the beach house, the glass walls allow a more profound see through into what might have been the choice that created the divergent split between her past and new self. Bonnie starts addressing the need to reshape her life with the same mastery she reshapes old furniture so she can rebrand her existence and sense of self. As the night falls, Bonnie is invited to a private party on the beach by some of Lizz's influent friends. There, she meets an intriguing young author called Barbara (Patricia's alter ego) who seems strangely familiar even though she can't locate from where. They talk about Barbara's newly published novel \"Man Shall Never Know Any Of This\" and what is truly the secret that humanity shall never know about. As this mysterious author provides a hint that might change Bonnie's future, the starry sky above them seems to swallow Bonnie into a life where the present becomes a choice point with a myriad of possibilities for the future, possibly reconciling the split she is experiencing in her life.",
    ],
    keywords: [
      "marriage",
      "relationships",
      "therapy",
      "past and future",
      "family relations",
      "love of one's life",
      "midlife crisis",
      "self-involved",
      "life changing situation",
      "uncover truth",
      "fantasies",
      "subconscious programming",
      "marital problem",
      "road trip",
      "female friendship",
      "strong female lead",
      "suburban life",
      "self-discovery",
      "mystery of one's existence",
    ],
    themes:
      "marriage, relationships, therapy, past and future, family relations, love of one's life, midlife crisis, self-involved, life changing situation, uncover truth, fantasies, subconscious programming, marital problem, road trip, female friendship, strong female lead, suburban life, self-discovery, mystery of one's existence.",
    visualStyle:
      "Warm, vivid & vibrant coral colored tones (summer-like) with comic add ups, optical special effects with matte painting and animation (interdimensional futuristic like) blending known and unknown elements in the screen.",
    visualReferences:
      "Trance 2013, Awake 2012 (tv series), Russian Doll 2019 (tv series), Poker Face 2023 (tv series).",
    images: [
      require("@/assets/images/Patricia/images/ep3/1.jpg"),
      require("@/assets/images/Patricia/images/ep3/2.jpg"),
      require("@/assets/images/Patricia/images/ep3/3.jpg"),
      require("@/assets/images/Patricia/images/ep3/4.jpg"),
      require("@/assets/images/Patricia/images/ep3/5.jpg"),
      require("@/assets/images/Patricia/images/ep3/6.jpg"),
      require("@/assets/images/Patricia/images/ep3/7.jpg"),
      require("@/assets/images/Patricia/images/ep3/8.jpg"),
      require("@/assets/images/Patricia/images/ep3/9.jpg"),
      require("@/assets/images/Patricia/images/ep3/10.jpg"),
      require("@/assets/images/Patricia/images/ep3/11.jpg"),
      require("@/assets/images/Patricia/images/ep3/12.jpg"),
      require("@/assets/images/Patricia/images/ep3/13.jpg"),
      require("@/assets/images/Patricia/images/ep3/14.jpg"),
      require("@/assets/images/Patricia/images/ep3/15.jpg"),
      require("@/assets/images/Patricia/images/ep3/16.jpg"),
      require("@/assets/images/Patricia/images/ep3/17.jpg"),
      require("@/assets/images/Patricia/images/ep3/18.jpg"),
      require("@/assets/images/Patricia/images/ep3/19.jpg"),
      require("@/assets/images/Patricia/images/ep3/20.jpg"),
    ],
  },
  {
    id: 4,
    title: "Aaron, 2015",
    fullText: [
      "The fourth episode opens with Aaron, 45, and his girlfriend Barbara (Patricia's alter ego), 22, on a shamanic retreat in California's desert looking at the moon. Barbara is telling Aaron about a native american legend as we forward back to the events that lead to that moment in time. Barbara is a young author who is just finishing her first novel. Aaron is a middle age journalist who feels lost in his own life, confronted with a past lover who resurfaces from time to time just to cause havoc in his new relationships, forcing him to either uplevel to a new horizon or go back to the patterns he already knows. Barbara and Aaron met a few years back and have been dating ever since despite the polemic their age gap caused in the beginning. What was once a passionate love affair turned into a solid relationship until the unexpected return of Aaron's ex that installed doubt in the relationship. One night, as they play their habitual game of picturing improbable experiences that they could enact, Barbara imagines the two of them performing a shamanic ritual for a crowd that leaves the experience profoundly transformed. As her vision and idea grow from that night on, she becomes moved by a wave of intuitive obsession on shamanism, the long forgotten invisible panther that used to spoon her to sleep when she was a kid and the unshakable knowing that the vision was merely a fragment from her subconscious trying to awaken her to what could be a reality. As Barbara starts studying shamanism with the intent of bridging that into her novel Man Will Never Know Any Of This, pieces of her past lives and learned gifts resurface and awaken the desire to learn more about the mystery of other lives lived and what else lies in her subconscious to be retrieved. Barbara then decides to travel to Mono Lake so she can awaken something unconscious in her. As she sleeps alone in the wilderness she enters into a dream that serves as a gateway to another dimension, activating her role as a shaman and revealing the path to mystic initiation. As Barbara returns visibly transformed and shares with Aaron what she went through, she also announces that they must recreate the ritual as they imagined it that night. Ready for a life changing adventure in the flavor of gonzo journalism, the couple travels to a shamanic retreat in Toiyabe for a life changing experience that will shape them as individuals and cross the boundaries of what they deem real. What started as a game rapidly turns into an out of body transformative experience that, to much of Aaron's surprise, brings them together in a soulful and unforgettable way. As the episode ends up exactly where it began, they both stand under the stars that are glimmering at a distance, feeling the clarity of their new founded perspective as Venus shines brighter in the sky indicating what might be the next step forward.",
    ],
    keywords: [
      "writer",
      "novel",
      "romantic relationship",
      "research",
      "writer's life",
      "native american",
      "shamanism",
      "shaman",
      "tribe",
      "past lives",
      "subconscious memories",
      "panther",
      "spirit animal",
      "nature",
      "wilderness",
      "history",
      "self-discovery",
      "indigenous people",
      "dream",
      "hallucination",
      "trance",
      "shapeshifting",
      "metamorphosis",
      "life altering experience",
      "rebirth ritual",
      "cultural difference",
      "magic realism",
      "surrealism",
      "age difference",
      "breakup and reconciliation",
      "past and future",
      "roadtrip",
      "dream sequence",
      "mystic dream",
    ],
    themes:
      "Writer, novel, romantic relationship, research, writer's life, native american, shamanism, shaman, tribe, past lives, subconscious memories, panther, spirit animal, nature, wilderness, history, self-discovery, indigenous people, dream, hallucination, trance, shapeshifting, metamorphosis, life altering experience, rebirth ritual, cultural difference, magic realism, surrealism, age difference, breakup and reconciliation, past and future, roadtrip, dream sequence, mystic dream.",
    visualStyle:
      "warm, earthy rich colored tones (autumn-like) in a 60's new age aesthetic. Handheld cameras providing more personal and spontaneous shots, with a documentary style and authentic intimacy.",
    visualReferences:
      "Woman Walks Ahead (2017), Embrace of the Serpent (2015), Dead Man (1995), Cat People (1982), Fear and Loathing in Las Vegas (1998).",
    images: [
      require("@/assets/images/Patricia/images/ep4/1.jpg"),
      require("@/assets/images/Patricia/images/ep4/2.jpg"),
      require("@/assets/images/Patricia/images/ep4/3.jpg"),
      require("@/assets/images/Patricia/images/ep4/4.jpg"),
      require("@/assets/images/Patricia/images/ep4/5.jpg"),
      require("@/assets/images/Patricia/images/ep4/6.jpg"),
      require("@/assets/images/Patricia/images/ep4/7.jpg"),
      require("@/assets/images/Patricia/images/ep4/8.jpg"),
      require("@/assets/images/Patricia/images/ep4/9.jpg"),
      require("@/assets/images/Patricia/images/ep4/10.jpg"),
      require("@/assets/images/Patricia/images/ep4/11.jpg"),
      require("@/assets/images/Patricia/images/ep4/12.jpg"),
      require("@/assets/images/Patricia/images/ep4/13.jpg"),
      require("@/assets/images/Patricia/images/ep4/14.jpg"),
      require("@/assets/images/Patricia/images/ep4/15.jpg"),
      require("@/assets/images/Patricia/images/ep4/16.jpg"),
      require("@/assets/images/Patricia/images/ep4/17.jpg"),
      require("@/assets/images/Patricia/images/ep4/18.jpg"),
      require("@/assets/images/Patricia/images/ep4/19.jpg"),
    ],
  },
  {
    id: 5,
    title: "Shawn, 2013",
    fullText: [
      "The fifth episode opens with Shawn, 43, at dawn, looking at the bedroom's ceiling with a planetarium app and a planetarium projector, putting both venus and neptune in focus, while stating that neptune is now erect. Next to him is Barbara, 20, half asleep and naked from their lovemaking. As they play with the constellations and stars on the bedroom's ceiling, they talk about myths and make up stories about the gods and their inevitable fates, until Barbara leans on Shawn and they have sex once again. Afterwards, as Barbara falls asleep, Shawn turns on a Lenny Bruce video and smokes cigarettes in what seems to be his dungeon of sex, alcohol and comedy. Shawn is a stand-up comedian easily seduced by the Neptunian's rays of poetic love, famous among his friends by his long history dating the wrong Barbaras. He has two kids with different Barbaras and is now dating his third, the youngest and most eccentric. As we slide in and out of one of the regularly entertaining days of his life, after he drops Barbara at home, he goes to his parents house for a short visit that changes the course of his life. After lunch, in the mist of heartfelt jokes and riddles an unexpected confession from his father leads to the unveiling of a truth that might upset the flamboyant romance he is experiencing with his new Barbara. As his siren young girlfriend keeps texting him for another fiery date, Shawn is confronted with a decision that will inadvertedly change the course of his life and their relationship. As he picks Barbara up for an afternoon of dangerous revelations or ardent lovemaking, the choice is his, Shawn asks neptune for a sign on what he should do. As he is driving distracted by Barbara's beauty, they hit on another car and Shawn takes the clue and makes up his mind. They drive to his house and by the end of the day, as he leans back in bed intoxicated by her scent, he reminisces on the unexpected turn that day provided. As he faces the ceiling with his projector and app, looking at the constellations that make up drawings on the wall, an alarm clock rings and his consciousness fades in with the figures, opening a door to another timeline.",
    ],
    keywords: [
      "femme fatale",
      "godlike main character",
      "immature man",
      "stand-up comedian",
      "womanizer",
      "sexual relations",
      "drugs & alcohol",
      "age difference",
      "older man younger woman relationship",
      "love affair",
      "forbidden love",
      "lust",
      "desire",
      "lifestyle",
      "dark humor",
      "comedian's life",
      "nudity",
      "family problems",
      "confession and revelations",
      "family relations",
      "semi serious",
      "humorous",
      "dating",
      "erotica",
      "sex scene",
      "illegitimate daughter",
      "perversion",
      "compulsion",
      "romantic entanglement",
    ],
    themes:
      "Femme fatale, godlike main character, immature man, stand-up comedian, womanizer, sexual relations, drugs & alcohol, age difference, older man younger woman relationship, love affair, forbidden love, lust, desire, lifestyle, dark humor, comedian's life, nudity, family problems, confession and revelations, family relations, semi serious, humorous, dating, erotica, sex scene, illegitimate daughter, perversion, compulsion, romantic entanglement.",
    visualStyle:
      "cool & contrasted tones, low icy lights, dark deep backgrounds, ghost-like (winter-like) in a liminal hybrid aesthetic. The footage will feel immersive, personal, both taking us in close up shots of details and out into the big picture.",
    visualReferences:
      "Mad Men 2007 (tv series), Californication 2007 (tv series), Hung 2009 (tv series), The Long Goodbye (1973), Lenny (1974).",
    images: [
      require("@/assets/images/Patricia/images/ep5/1.jpg"),
      require("@/assets/images/Patricia/images/ep5/2.jpg"),
      require("@/assets/images/Patricia/images/ep5/3.jpg"),
      require("@/assets/images/Patricia/images/ep5/4.jpg"),
      require("@/assets/images/Patricia/images/ep5/5.jpg"),
      require("@/assets/images/Patricia/images/ep5/6.jpg"),
      require("@/assets/images/Patricia/images/ep5/7.jpg"),
      require("@/assets/images/Patricia/images/ep5/8.jpg"),
      require("@/assets/images/Patricia/images/ep5/9.jpg"),
      require("@/assets/images/Patricia/images/ep5/10.jpg"),
      require("@/assets/images/Patricia/images/ep5/11.jpg"),
      require("@/assets/images/Patricia/images/ep5/12.jpg"),
      require("@/assets/images/Patricia/images/ep5/13.jpg"),
      require("@/assets/images/Patricia/images/ep5/14.jpg"),
      require("@/assets/images/Patricia/images/ep5/15.jpg"),
      require("@/assets/images/Patricia/images/ep5/16.jpg"),
      require("@/assets/images/Patricia/images/ep5/17.jpg"),
      require("@/assets/images/Patricia/images/ep5/18.jpg"),
      require("@/assets/images/Patricia/images/ep5/19.jpg"),
      require("@/assets/images/Patricia/images/ep5/20.jpg"),
      require("@/assets/images/Patricia/images/ep5/21.jpg"),
      require("@/assets/images/Patricia/images/ep5/22.jpg"),
      require("@/assets/images/Patricia/images/ep5/23.jpg"),
      require("@/assets/images/Patricia/images/ep5/24.jpg"),
    ],
  },
  {
    id: 6,
    title: "Episode 6",
    fullText: "Full content coming soon",
    keywords: ["coming soon"],
    themes: "Coming soon",
    visualStyle: "Coming soon",
    visualReferences: "Coming soon",
    images: [
      require("@/assets/images/Patricia/images/patricia_01.jpg"),
      require("@/assets/images/Patricia/images/patricia_01.jpg"),
      require("@/assets/images/Patricia/images/patricia_01.jpg"),
    ],
  },
  {
    id: 7,
    title: "Episode 7",
    fullText: "Full content coming soon",
    keywords: ["coming soon"],
    themes: "Coming soon",
    visualStyle: "Coming soon",
    visualReferences: "Coming soon",
    images: [
      require("@/assets/images/Patricia/images/patricia_01.jpg"),
      require("@/assets/images/Patricia/images/patricia_01.jpg"),
      require("@/assets/images/Patricia/images/patricia_01.jpg"),
    ],
  },
  {
    id: 8,
    title: "Episode 8",
    fullText: "Full content coming soon",
    keywords: ["coming soon"],
    themes: "Coming soon",
    visualStyle: "Coming soon",
    visualReferences: "Coming soon",
    images: [
      require("@/assets/images/Patricia/images/patricia_01.jpg"),
      require("@/assets/images/Patricia/images/patricia_01.jpg"),
      require("@/assets/images/Patricia/images/patricia_01.jpg"),
    ],
  },
  {
    id: 9,
    title: "Episode 9",
    fullText: "Full content coming soon",
    keywords: ["coming soon"],
    themes: "Coming soon",
    visualStyle: "Coming soon",
    visualReferences: "Coming soon",
    images: [
      require("@/assets/images/Patricia/images/patricia_01.jpg"),
      require("@/assets/images/Patricia/images/patricia_01.jpg"),
      require("@/assets/images/Patricia/images/patricia_01.jpg"),
    ],
  },
  {
    id: 10,
    title: "Episode 10",
    fullText: "Full content coming soon",
    keywords: ["coming soon"],
    themes: "Coming soon",
    visualStyle: "Coming soon",
    visualReferences: "Coming soon",
    images: [
      require("@/assets/images/Patricia/images/patricia_01.jpg"),
      require("@/assets/images/Patricia/images/patricia_01.jpg"),
      require("@/assets/images/Patricia/images/patricia_01.jpg"),
    ],
  },
  {
    id: 11,
    title: "Episode 11",
    fullText: "Full content coming soon",
    keywords: ["coming soon"],
    themes: "Coming soon",
    visualStyle: "Coming soon",
    visualReferences: "Coming soon",
    images: [
      require("@/assets/images/Patricia/images/patricia_01.jpg"),
      require("@/assets/images/Patricia/images/patricia_01.jpg"),
      require("@/assets/images/Patricia/images/patricia_01.jpg"),
    ],
  },
  {
    id: 12,
    title: "Episode 12",
    fullText: "Full content coming soon",
    keywords: ["coming soon"],
    themes: "Coming soon",
    visualStyle: "Coming soon",
    visualReferences: "Coming soon",
    images: [
      require("@/assets/images/Patricia/images/patricia_01.jpg"),
      require("@/assets/images/Patricia/images/patricia_01.jpg"),
      require("@/assets/images/Patricia/images/patricia_01.jpg"),
    ],
  },
  {
    id: 13,
    title: "Episode 13",
    fullText: "Full content coming soon",
    keywords: ["coming soon"],
    themes: "Coming soon",
    visualStyle: "Coming soon",
    visualReferences: "Coming soon",
    images: [
      require("@/assets/images/Patricia/images/patricia_01.jpg"),
      require("@/assets/images/Patricia/images/patricia_01.jpg"),
      require("@/assets/images/Patricia/images/patricia_01.jpg"),
    ],
  },
];
